import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import IconComponent from "app/shared-components/IconComponent";
import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import UserForm from "./UserForm";
import UserFormPopup from "./UserFormPopup";
import { useMediaQuery, useTheme } from "@mui/material";
const UsersList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState();
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const childRef = useRef();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [modalName, setModalName] = useState();
  const [open, setOpen] = useState(false);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [tabValue, setTabValue] = useState(0);
  const [status, setStatus] = useState();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setTabValue(0);
  };

  const [columnDefs, setColumnDefs] = useState([
    { field: "name", enableRowGroup: true, minWidth: 50 },
    { field: "country", enableRowGroup: true, minWidth: 50 },
    {
      field: "companyName",
      enableRowGroup: true,
      headerName: "Partner",
      minWidth: 50,
    },
    {
      field: "showroomName",
      enableRowGroup: true,
      headerName: "Showroom",
      minWidth: 50,
    },
    { field: "roles", enableRowGroup: true, minWidth: 50 },
    { field: "active", cellRenderer: IconComponent, minWidth: 50 },
  ]);
  const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

  const handlePurge = async () => {
    gridApi?.showLoadingOverlay();
    try {
      await Promise.all(
        selectedRows.map((row) => {
          const userId = row?._links?.user?.href.split("/").pop();
          return OAuthService.deleteData(url, userId);
        })
      );
      setSuccessMsg("Data deleted Successfully");
      setSnackState(true);
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
    gridRef.current?.api?.deselectAll();
    loadData();
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Users.xlsx",
      sheetName: "Users",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    // window.addEventListener('resize', function () {
    //     setTimeout(function () {
    //       params.api.sizeColumnsToFit();
    //     });
    //   });
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const loadData = async () => {
    gridApi?.showLoadingOverlay();
    try {
      const list = await OAuthService.getList(
        url + `?sort=firstName,asc&size=1000`,
      );
      const users = list.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        return data;
      });
      setRowData(users);
    } catch (error) {
      setError(error.message);
    } finally {
      gridApi?.hideOverlay();
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = () => {
    if (!isMobile) {
      setOpen(true);
      setModalName("UPDATE USER");
    }
  };

  const onRowClicked = () => {
    if (isMobile) {
      setOpen(true);
      setModalName("UPDATE USER");
    }
  };
  const handleAddButton = (e) => {
    e.preventDefault();
    setSelectedRows();
    setOpen(true);
    setModalName("ADD USER");
  };

  const handleSave = () => {
    const childelement = childRef.current;
    const submitData = childelement.handleSubmit();
    submitData.then((val) => {
      if (val) {
        setOpen(false);
        setSuccessMsg(val);
        setSnackState(true);
        loadData();
      }
    });
  };

  const checkedStatus = (st) => {
    setStatus(st);
  };

  useEffect(() => {
    checkedStatus();
  }, []);
  return (
    <>
      <ListPageHeader
        componentName="User"
        onBtExport={onBtExport}
        // handlePurge={handlePurge}
        handleAddButton={handleAddButton}
        // addPageLink="/addUser"
        pageName="User List"
        error={error}
        successMsg={successMsg}
        setSnackState={setSnackState}
        snackState={snackState}
        gridRef={gridRef}
      />
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          onRowClicked={onRowClicked}
          gridRef={gridRef}
          rowData={rowData}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"userList"}
        />
      </div>

      <Dialog
        fullWidth
        fullScreen={isMobile}
        maxWidth={"lg"}
        onClose={handleClose}
        open={open}
      >
        <DialogTitle sx={{ p: { xs: 2, sm: 3 } }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography
              variant="h6"
              component="span"
              sx={{
                fontSize: { xs: "1rem", sm: "1.25rem" },
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {modalName}
            </Typography>
            <IconButton
              onClick={handleClose}
              size="small"
              sx={{ flexShrink: 0 }}
            >
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent dividers sx={{ p: { xs: 1.5, sm: 3 } }}>
          <UserFormPopup
            id={
              selectedRows &&
              selectedRows[0]?._links?.user?.href.split("/").pop()
            }
            ref={childRef}
            checkedStatus={checkedStatus}
            tabValue={tabValue}
            setTabValue={setTabValue}
          />
        </DialogContent>

        <DialogActions sx={{ p: { xs: 1.5, sm: 2 } }}>
          {tabValue !== 1 && (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSave}
              disabled={status}
              fullWidth={isMobile}
            >
              <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UsersList;
